import React, { useEffect, createElement } from 'react';
import AdvertorialGlpAdv3 from '../components/AdvertorialGlpAdv3';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpAdv3Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv3
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'GLP-1 Brain Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'GLP-1 Brain Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'GLP-1 Brain Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-2512">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-2513">
        <Helmet data-id="element-2514">
          <title data-id="element-2515">
            Investigative Report: What Happens To Your Brain's Reward System On
            GLP-1 Drugs—And Why It's Not In The Prescribing Information
          </title>
          <meta property="og:title" content="Investigative Report: What Happens To Your Brain's Reward System On GLP-1 Drugs—And Why It's Not In The Prescribing Information" data-id="element-2516" />
          <meta property="og:description" content="The Breakthrough Discovery From Uppsala University Research That Saved My Sister - And Is Allowing Over 36,700 People To Continue Losing Weight With NO Depression, Anxiety, Numbness, Disconnected Feeling, Loss Of Motivation, Insomnia, Nightmares or Sense Of Dread" data-id="element-2517" />
          <meta property="og:type" content="article" data-id="element-2518" />
          <meta property="og:url" content={window.location.href} data-id="element-2519" />
          <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-2520" />
          <meta property="og:image:width" content="1200" data-id="element-2521" />
          <meta property="og:image:height" content="630" data-id="element-2522" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-2523" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-2524" />
          <meta name="twitter:title" content="Investigative Report: What Happens To Your Brain's Reward System On GLP-1 Drugs—And Why It's Not In The Prescribing Information" data-id="element-2525" />
          <meta name="twitter:description" content="The Breakthrough Discovery From Uppsala University Research That Saved My Sister - And Is Allowing Over 36,700 People To Continue Losing Weight With NO Depression, Anxiety, Numbness, Disconnected Feeling, Loss Of Motivation, Insomnia, Nightmares or Sense Of Dread" data-id="element-2526" />
          <meta name="twitter:url" content={window.location.href} data-id="element-2527" />
          <meta name="twitter:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-2528" />
        </Helmet>
        <AdvertorialGlpAdv3 data-id="element-2529" />
      </div>
    </HelmetProvider>;
}